import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "bg-white bg-opacity-75 border",
    style: { "position": "absolute", "height": "100%", "width": "100%", "z-index": "5000" }
};
const _hoisted_2 = { style: { "position": "absolute", "top": "50%", "left": "50%", "transform": "translate(-50%, -50%)" } };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.isActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", {
                    class: _normalizeClass(['g-loader', 'g-loader-' + _ctx.color]),
                    style: _normalizeStyle({ width: _ctx.size })
                }, null, 6)
            ])
        ]))
        : _createCommentVNode("", true);
}
